import CrownRounded from "../../assets/icons/crown-rounded";
import UserRounded from "../../assets/icons/user-rounded";

export default function PvStatsUsers({ pv }) {
  const handleClose = async () => {
    document.querySelector("#close-modal-button").click();
  };

  return (
    <div>
      <h3 className="my-2">UTENTI PER PV: {pv.pv.codicePv}</h3>
      <div className="py-2 border-top mb-3">
        <span>{pv.pv.codiceDistrict}</span>
        <strong className="mx-2">{">"}</strong>
        <span>{pv.pv.codiceArea}</span>
        <strong className="mx-2">{">"}</strong>
        <span>
          {pv.pv.nomeRcr} {pv.pv.cognomeRcr}
        </span>
      </div>
      <div
        style={{ maxHeight: 500 }}
        className="d-flex gap-2 flex-column overflow-auto w-100"
      >
        {pv.utentiList &&
          pv.utentiList.map((item, index) => {
            return (
              <div
                style={{
                  minWidth: "100%",
                  background: item.active ? "#ffffff" : "#f5f5f5",
                  opacity: item.active ? 1 : 0.6,
                }}
                key={index}
                className="p-3 shadow-sm rounded d-flex border align-items-center"
              >
                {!item.parentId ? (
                  <CrownRounded color="#20419a" className="me-3" size={35} />
                ) : (
                  <UserRounded color="#a0a0a0" className="me-3" size={35} />
                )}

                <div>
                  <strong className="d-block mb-1">
                    {item.firstName} {item.lastName}
                  </strong>
                  <small className="d-block">{item.email}</small>
                  <small>
                    Ultimo accesso il:{" "}
                    <strong>
                      {item.lastHeartbeatDate
                        ? new Date(item.lastHeartbeatDate).toLocaleDateString()
                        : " --/--/----"}
                    </strong>
                  </small>
                </div>
              </div>
            );
          })}
      </div>
      <div className="d-flex gap-3 w-100 justify-content-end mt-4">
        <button
          className="q8-blue-button py-2 px-4"
          onClick={() => handleClose()}
          type="button"
        >
          CHIUDI
        </button>
      </div>
    </div>
  );
}
